import { render, staticRenderFns } from "./depModal.vue?vue&type=template&id=a87e5ab4&scoped=true&"
import script from "./depModal.vue?vue&type=script&lang=js&"
export * from "./depModal.vue?vue&type=script&lang=js&"
import style0 from "./depModal.vue?vue&type=style&index=0&id=a87e5ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87e5ab4",
  null
  
)

export default component.exports